import {useTranslation} from "react-i18next";
import {Link, useParams} from "react-router-dom";
import useEventProgram, {updateReportStatus} from "../../hooks/useEventProgram";
import classNames from "classnames";

export default function Report({ id }) {
    const { t } = useTranslation();
    const { reportId } = useParams();
    const [programData, dispatch] = useEventProgram(id);

    if (!programData) {
        return null;
    }
    const report = programData.reports[reportId];
    const section = report.section;
    const sectionDate = new Date(section.date);
console.log(section);
    return (
        <div className="tab-panel active" id="reports">
            <div className={'report-info'}>
                <div className="sub-breadcrumbs js-return-to-reportsList">
                    <ul>
                        <li><Link to={`/conference/${id}/reports`}><i
                            className="icon-back"/>{t('conferences.conference.toReports')}</Link></li>
                    </ul>
                </div>
                <div className="js-report-info wysiwyg-content">
                    <div>
                        <h3>{report.section.name}</h3>
                        <p className="date">
                            {sectionDate.toLocaleString('uk', {timeZone: 'UTC', day: '2-digit', month: 'long'})}{ ', ' }
                            {
                                (!!section.timeStart && !!section.timeEnd) ?
                                    <>{section.timeStart} - {section.timeEnd} </> :
                                    !!section.timeStart ? <>{section.timeStart}</> :
                                        section.timeEnd ? <>{section.timeEnd}</> : null
                            }
                        </p>
                        <h4 className="name">{report.name}</h4>
                        <p className="author">
                            {
                                report.authors.map(
                                    (author, index) => {
                                        return (
                                            <>
                                                <Link to={`/conference/${id}/speakers/${author.id}`}
                                                      className="js-author-link">{author.lastName} {author.firstName} {author.middleName}</Link>
                                                {
                                                    report.authors.length > 1 && report.authors.length !== index + 1 && ', '
                                                }
                                            </>
                                        )
                                    }
                                )
                            }
                        </p>
                        <div onClick={
                            report.isUserSelected ?
                                () => updateReportStatus(id, report.elementId, report.id, dispatch, 'DELETE') :
                                () => updateReportStatus(id, report.elementId, report.id, dispatch, 'POST')
                        } className={'add-report'}>
                            <i
                                className={classNames({"icon-plus": !report.isUserSelected, "icon-done": report.isUserSelected})}
                            />
                            { report.isUserSelected ? t('conferences.conference.addedToOwnProgram') : t('conferences.conference.addToOwnProgram')}
                        </div>
                        {
                            !!report.presentation &&
                            <div className="report-iframe">
                                <iframe
                                    src={`https://drive.google.com/viewerng/viewer?embedded=true&url=https://${window.location.hostname}/${report.presentation}`}
                                    width="100%" height="100%" allowFullScreen/>
                            </div>
                        }
                        {report.description}
                    </div>
                </div>
            </div>
        </div>
    );
}
